export default {
  // async
  SET_NAME_TUTORIAL_ITEM: 'SET_NAME_TUTORIAL_ITEM',
};
